import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is the best ethical hacking course in Jaipur?",
      answer: "Indian Cyber Club Academy offers the best ethical hacking course in Jaipur with 100% practical training, live labs, and industry certifications. Our comprehensive course covers penetration testing, VAPT, bug bounty hunting, network security, and more with placement support. We have trained 30,000+ students with a 95% success rate."
    },
    {
      question: "Do you provide offline training in Jaipur?",
      answer: "Yes, we offer both offline classroom training in Jaipur and online courses. Our offline training provides face-to-face interaction with instructors, hands-on lab sessions, and peer learning opportunities. We also offer hybrid options combining online and offline sessions for maximum flexibility."
    },
    {
      question: "Do you offer online courses across India?",
      answer: "Absolutely! Our online courses are available across India and globally. You can learn from anywhere with live instructor-led sessions, recorded lectures, 30+ days of lab access, and comprehensive study materials. Students from all states of India have successfully completed our programs."
    },
    {
      question: "What is VAPT training?",
      answer: "VAPT (Vulnerability Assessment and Penetration Testing) training teaches you to identify security vulnerabilities in systems and networks. Our VAPT course covers scanning techniques, exploitation methods, report writing, and real-world scenarios. You'll master tools like Nmap, Metasploit, Burp Suite, and more."
    },
    {
      question: "Is placement support available?",
      answer: "Yes, we provide comprehensive placement support including resume building, interview preparation, mock interviews, and connections with 500+ hiring partners including TCS, Infosys, Wipro, and more. We have a 95% placement success rate with average packages of 12 LPA."
    },
    {
      question: "Can beginners join the ethical hacking course?",
      answer: "Yes! We offer courses for all skill levels. Our beginner-friendly courses start with fundamentals of networking, Linux, and programming before advancing to ethical hacking techniques. No prior cybersecurity experience is required. Our expert instructors guide you step-by-step from basics to advanced concepts."
    },
    {
      question: "Can college students join the ethical hacking course?",
      answer: "Absolutely! College students are welcome to join our courses. We offer special student pricing and flexible scheduling options. Many of our students are currently pursuing degrees in computer science, IT, or related fields while learning cybersecurity skills with us."
    },
    {
      question: "What certifications will I receive after course completion?",
      answer: "Upon successful completion, you'll receive an industry-recognized certificate from Indian Cyber Club Academy. Additionally, our courses prepare you for prestigious certifications like CEH (Certified Ethical Hacker), CompTIA Security+, OSCP, and more. We also provide guidance and support for taking these certification exams."
    },
    {
      question: "How long is the cybersecurity course duration?",
      answer: "Course durations vary based on the program: Live instructor-led courses range from 2-6 months, self-paced courses can be completed at your own speed (3-12 months), and Advance Training programs are 6-12 months. All courses include 30+ days of live lab access for hands-on practice."
    },
    {
      question: "What is the fee structure for cybersecurity courses?",
      answer: "Course fees vary based on the program type and duration. We offer competitive pricing with EMI options available. Contact us at +91-9694612895 for detailed fee structure and current offers. We frequently run special discounts and early bird offers for new batches."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 sm:py-24 bg-gradient-to-br from-gray-950 via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600 rounded-full filter blur-3xl animate-pulse"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <HelpCircle className="w-4 h-4 sm:w-5 sm:h-5 text-red-500" />
            <span className="text-red-500 font-semibold text-xs sm:text-sm uppercase tracking-wider">FAQ</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 sm:mb-6 px-4">
            Frequently Asked{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">
              Questions
            </span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base lg:text-lg px-4">
            Everything you need to know about our cybersecurity courses in Jaipur
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-900/50 backdrop-blur-sm border-2 border-gray-800 hover:border-red-500/50 rounded-xl transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left group"
              >
                <h3 className="text-sm sm:text-base lg:text-lg font-bold text-white group-hover:text-red-500 transition-colors pr-4">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 sm:w-6 sm:h-6 text-red-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 sm:px-6 pb-4 sm:pb-6 pt-0">
                  <p className="text-xs sm:text-sm lg:text-base text-gray-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-gray-400 text-sm sm:text-base mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="https://wa.me/919694612895"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg shadow-red-500/30 hover:shadow-red-500/50 hover:scale-105"
          >
            Contact Us on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
